import React from 'react';

import { LEGAL_DOCUMENTS } from '../content/legalDocuments';
import LegalDocumentPage from './LegalDocumentPage';

export default function TermsOfUsePage() {
    const { title, pdf } = LEGAL_DOCUMENTS.termsOfUse;
    return <LegalDocumentPage title={title} pdf={pdf} />;
}
